import { useUser } from '@clerk/react';

export function useHiUser() {
  const { isSignedIn, user } = useUser();

  if (!isSignedIn || !user) {
    return null;
  }

  return {
    userName: user.fullName || '',
    userEmail: user.primaryEmailAddress?.emailAddress || '',
  };
}
